module.exports = __webpack_public_path__ + "static/media/Daedalus.f10636ec.jpg";